import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useCallback, useEffect } from 'react';
import { Alert, AlertTitle, Snackbar } from '@mui/material';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { closeSnakeError } from './redux/actions';
import { useBooleanState } from 'shared/hooks/state/boolean';
export const ErrorSnack = memo(function ErrorSnackImpl(props) {
    const [showed, close, show] = useBooleanState(!!props.open);
    useEffect(() => {
        if (props.open) {
            show();
        }
    }, [props.open]);
    const onClose = useCallback(() => {
        close();
        props.onClose?.();
    }, []);
    return (_jsx(Snackbar, { open: showed, autoHideDuration: 5000, ...props, children: _jsx(Alert, { onClose: onClose, severity: "error", children: _jsx(AlertTitle, { children: props.error }) }) }));
});
export const ErrorSnackRedux = memo(function ErrorSnackImpl() {
    const { open, error } = useAppSelector((state) => state.snake_error);
    const onClose = useAction(closeSnakeError);
    return _jsx(ErrorSnack, { open: open, error: error, onClose: onClose });
});
